import { request } from "./http";

export interface Candle {
  timestamp: number;
  open: number;
  high: number;
  low: number;
  close: number;
  volume: number;
}

export interface DepthLevel {
  price: string;
  size: string;
}

export interface DepthSnapshot {
  symbol: string;
  bids: [string, string][];
  asks: [string, string][];
  mid: number | null;
}

export const market = {
  candles: (symbol: string, tf: number) =>
    request<Candle[]>(`/piggy/api/price-data/${symbol}?tf=${tf}`),
  depth: (symbol: string, levels = 10) =>
    request<DepthSnapshot>(`/piggy/api/depth/${symbol}?levels=${levels}`),
};
